import { AssetManagementIntegrationRunStatus, AssetManagementIntegrationStatus, IntegrationsStatusDocument } from "~/graphql/generated/graphql";
import { useApolloClient } from "@vue/apollo-composable";

export const useSideMenuWarnings = async () => {
  const { resolveClient } = useApolloClient();
  const client = resolveClient();

  const status = await client.query({ query: IntegrationsStatusDocument });

  const integrationWarnings =
    status.data.integrations?.filter(
      (integration) =>
        integration.status != AssetManagementIntegrationStatus.Offline && integration.latestRun?.status === AssetManagementIntegrationRunStatus.Failed
    ).length ?? 0;

  const warnings = [{ menuItem: MenuItemType.INTEGRATION_HUB, count: integrationWarnings }];

  return { warnings };
};
